import SettingsContent from '../Wrapper.vue';
import LocationsIndex from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/locations'),
      component: SettingsContent,
      props: {
        headerTitle: 'LOCATIONS.HEADER',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'locations_wrapper',
          redirect: 'locations_index',
        },
        {
          path: 'list',
          name: 'locations_index',
          component: LocationsIndex,
          meta: {
            permissions: ['administrator', 'location_manage'],
          },
        },
      ],
    },
  ],
};
